import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LogInView.vue'
import ResetView from '@/views/ResetView.vue'
import LocationView from '@/views/LocationView.vue'
import SsoView from '@/views/SsoView.vue'
import ProfileView from '@/views/ProfileView.vue'
import InvoiceReviewView from '@/views/InvoiceReviewView.vue'
import OnboardView from '@/views/OnboardView.vue'
import InvoicesView from '@/views/InvoicesView.vue'
import DashboardView from '@/views/DashboardView.vue'
import LearnMore from '@/views/LearnMore.vue'
import TermsOfServiceView from '@/views/TermsOfServiceView.vue'
import PrivacyPolicyView from '@/views/PrivacyPolicyView.vue'
import ExtensionView from '@/views/ExtensionView.vue'
export default [
  {
    path: '/login',
    name: 'login',
    meta: { allowAnonymous: true },
    component: LoginView
  },
  {
    path: '/sso',
    name: 'sso',
    meta: { allowAnonymous: true },
    component: SsoView
  },
  {
    path: '/reset',
    name: 'reset',
    meta: { allowAnonymous: true },
    component: ResetView
  },
  {
    path: '/',
    name: 'home',
    meta: { layout: 'side-nav' },
    component: HomeView
  },
  {
    path: '/learn-more',
    name: 'learn-more',
    meta: { allowAnonymous: true },
    component: LearnMore
  },
  {
    path: '/onboard',
    name: 'onboard',
    meta: { allowAnonymous: true },
    component: OnboardView
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { layout: 'default' },
    component: ProfileView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { layout: 'default' },
    component: DashboardView
  },
  {
    path: '/locations',
    name: 'locations',
    meta: { layout: 'default' },
    component: LocationView
  },
  {
    path: '/invoice-review',
    name: 'invoice-review',
    meta: { layout: 'default' },
    component: InvoiceReviewView
  },
  {
    path: '/invoices',
    name: 'invoices',
    meta: { layout: 'default' },
    component: InvoicesView
  },
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    meta: { allowAnonymous: true },
    component: TermsOfServiceView
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    meta: { allowAnonymous: true },
    component: PrivacyPolicyView
  },
  {
    path: '/extension',
    name: 'extension',
    meta: { layout: 'default' },
    component: ExtensionView
  },
  {
    path: '/about',
    name: 'about',
    meta: { layout: 'default' },
    // route level code-splitting
    // this generates a separate chunk (About.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/AboutView.vue')
  }
]
